export default "__VITE_ASSET__aLHsVDF2__"